import Logo from "../assets/images/logo.png";
import "../assets/css/footer.css";
import FaceBook from "../assets/images/facebook.svg";
import LinkedIn from "../assets/images/linkedIn.svg";
import Twitter from "../assets/images/twitter.svg";
import Youtube from "../assets/images/youtube.svg";
import Instagram from "../assets/images/instagram.svg";

import React from "react";

const Footer = () => {
  return (
    <div className="footer">
      <div className="footer-top">
        <div className="footer-logo">
          <img src={Logo} alt="Your Logo" />
        </div>
        <div className="footer-content">
          <a href="https://kpmg.com/ng/en/home/misc/contact.html">Contact Us</a>
          <a href="https://kpmg.com/ng/en/home/misc/legal.html">Legal</a>
          <a href="https://kpmg.com/ng/en/home/misc/privacy.html">Privacy</a>
          <div className="footer-social-icons">
            <a href="https://web.facebook.com/kpmg.ng">
              <img src={FaceBook} alt="logo" className="fab fa-facebook" />
            </a>
            <a href="https://www.linkedin.com/company/kpmg_nigeria/">
              <img src={LinkedIn} alt="logo" className="fab fa-linkedIn" />
            </a>
            <a href="https://x.com/KPMG_NG?s=20">
              <img src={Twitter} alt="logo" className="fab fa-twitter" />
            </a>{" "}
            <a href="https://www.instagram.com/kpmg_nigeria/">
              <img src={Instagram} alt="logo" className="fab fa-instagram" />
            </a>{" "}
            <a href="https://www.youtube.com/@KPMGNigeriaChannel">
              <img src={Youtube} alt="logo" className="fab fa-youtube" />
            </a>
          </div>
        </div>
      </div>
      <div className="footer-divider"></div>
      <div className="footer-powered">
        Powered by{" "}
        <span style={{ fontWeight: "bold" }}> KPMG Digital Factory</span>
      </div>
      <div>
        <p className="footer-message">
          © 2024 KPMG Professional Services, a partnership registered in Nigeria
          and a member firm of the KPMG global organisation of independent
          member firms affiliated with KPMG International Limited, a private
          English company limited by guarantee. All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default Footer;
